import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=52c8a706&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "./Services.vue?vue&type=style&index=0&id=52c8a706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8a706",
  null
  
)

export default component.exports